import { render, staticRenderFns } from "./StoreApplication.vue?vue&type=template&id=2b03c4fb&scoped=true"
import script from "./StoreApplication.vue?vue&type=script&lang=js"
export * from "./StoreApplication.vue?vue&type=script&lang=js"
import style0 from "./StoreApplication.vue?vue&type=style&index=0&id=2b03c4fb&prod&scoped=true&lang=css"
import style1 from "./StoreApplication.vue?vue&type=style&index=1&id=2b03c4fb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b03c4fb",
  null
  
)

export default component.exports